import React, { useEffect, useRef } from "react";
import CopyToClipboard from "./CopyToClipboard";
import CopyToClipboard2 from "./CopyToClipboard2";

export default function CopyToClipboardSelector({ text }) {
  let clipboardRef = useRef(null);

  useEffect(() => {
    if (clipboardRef.current) return;
    let random = Math.round(Math.random());
    clipboardRef.current = random;
  }, []);

  if (clipboardRef.current === 0) {
    return <CopyToClipboard text={text} />;
  }

  if (clipboardRef.current === 1) {
    return <CopyToClipboard2 text={text} />;
  }

  return <CopyToClipboard text={text} />;
}
